import { Dictionary } from "../../../../react-core/Helpers/CommonHelper";
import { DistributionChannel } from "../../../../Wrap/Constants/Enums/Domain/DistributionChannel";
import { FsaAuthorisationStatus } from "../../../../Wrap/Constants/Enums/Domain/FsaAuthorisationStatus";

export const ContentFilter = {
    title: {
        title: "Search criteria",
        search: "Search",
    },
    search: {
        processType: "Process type",
        networkType: "Network type",
        networkName: "Network name",
        reference: "FCA/Trading reference",
        createdBy: "Created by",
        dateStarted: "Date started",
        lastUpdated: "Last updated",
        postCode: "Postcode",
        from: "From",
        to: "To",
        networkId: "Network ID",
    },
};

export const ContentTable = {
    noDataMsg: "No results have been found for the entered criteria",
    header: {
        dateStarted: "Date started",
        processType: "Process type",
        status: "Status",
        networkName: "Network name",
        reference: "FCA/Trading reference",
        createdBy: "Created by",
        lastUpdated: "Last updated",
        postCode: "Postcode",
        action: "Action",
    },
    view: "VIEW",
    resume: "RESUME",
    delete: "Delete",
    sessions: "SESSIONS",
    editNotes: "Edit Notes",
    defaultUrl: "javascript:void(0);",
    save: "save",
    other: "Other",
    confirmDelete: "Are you sure you want to delete selected wizards?",
    noWizardSelected: "Please select wizard to delete",
    networkHistoryHeader: {
        networkId: "Network ID",
        networkName: "Network name",
        networkType: "Network type",
        reference: "FCA/Trading reference",
        FcaReferenceStatus: "FCA/Trading reference status",
        LinkedDaFirmName: "Linked DA firm name",
        postCode: "Postcode",
    },
};

export const CreatedbyOptions: Dictionary[] = [
    { key: 0, value: "Anyone" },
    { key: 1, value: "Me" },
];

export const ProcessTypeOptions: Dictionary[] = [
    { key: 0, value: "All" },
    { key: 1, value: "Create network" },
    { key: 2, value: "Edit network" },
];

export const NetworkTypeOptions: Dictionary[] = [
    { key: 0, value: "All" },
    { key: 1, value: "Network" },
    { key: 2, value: "Service provider" },
];

export const wizardStepperName = {
    serviceProvider: "Network details",
    validationAndExcute: "Validate and execute",
    network: "Network details",
    valuation: "Remuneration and valuation",
    confirmation: "Confirmation",
};

export const FsaAuthorisationStatusArray = [
    FsaAuthorisationStatus.Authorised,
    FsaAuthorisationStatus.Deauthorised,
    FsaAuthorisationStatus.Pendingauthorisation,
    FsaAuthorisationStatus.Eeaauthorised,
];

export const FsaAuthorisationStatusMap = {
    [FsaAuthorisationStatus.Authorised]: "Authorised",
    [FsaAuthorisationStatus.Deauthorised]: "De-authorised",
    [FsaAuthorisationStatus.Pendingauthorisation]: "Pending authorisation",
    [FsaAuthorisationStatus.Eeaauthorised]: "EEA authorised",
};

export const DistributionArray = [DistributionChannel.Adviser];

export const DistributionMap = {
    [DistributionChannel.Adviser]: "Adviser",
};

export const errorMsg = {
    noSpecial: "Must not contain special characters!",
    phone: "Invalid phone number!",
};
